import { Suspense } from "react";
import styles from "./PreLogin.module.scss";
import { Outlet } from "react-router-dom";
import Loader from "@/components/Loader/Loader";
import MonogramSVG from "@/assets/svg/LoginPage/MonogramSVG";

const PreLogin = () => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.brandHeader}>
        <div className={styles.logoBadge}>
          <MonogramSVG />
        </div>
        <p className={styles.brandName}>The Chartered</p>
        <p className={styles.brandTagline}>Admin Console</p>
      </div>

      <Suspense fallback={<Loader />}>
        <div className={styles.childrenContainer}>
          <Outlet />
        </div>
      </Suspense>

      <p className={styles.auditNote}>Every action in this console is written to the audit log.</p>
    </div>
  );
};

export default PreLogin;
